import { patientsPath } from "../patientsPath";

export const stepsPath = '/steps';
export const stepsFullPath = `${patientsPath}${stepsPath}`;